import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { TAB_NAMES } from 'components/pages/Templates/model'
import { toTemplates } from 'ducks/router'
import { useTable } from 'hooks'
import { jobTemplates } from 'orm'
import { getColumns, getRowActions } from './model'

const useJobsTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchJobTemplates = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      dispatch(
        jobTemplates.fetchStart({
          limit,
          department,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchJobTemplates,
  }
}

const useJobsTableData = () => {
  const data = useSelector(jobTemplates.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useJobsTable = state => {
  const { mapSortingPropToQueryParam, filter, search } = state

  const dispatch = useDispatch()

  const columns = getColumns()
  const rowActions = getRowActions()

  const { handleFetchJobTemplates } = useJobsTableMutations()

  const {
    state: { count, items, order },
  } = useJobsTableData()

  const handleRefetch = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      handleFetchJobTemplates({ limit, department, offset, ordering, search })
    },
    [handleFetchJobTemplates],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      dispatch(
        toTemplates(TAB_NAMES.JOBS, null, {
          limit,
          department,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: R.props(order, items),
    mapSortingPropToQueryParam,
    pageCount: count,
    filterQuery: filter,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        rowActions,
        isFetching,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
